import React from 'react'
import ICSButton from '../../../../components/ICS/Button/ICSButton'

const renderFiles = ({ e, toggleModal }) => {
  return e.data.files.length
    ? [
        <ICSButton
          id={e.row.data.id}
          key={e.row.data.id}
          className='result-file-button'
          type='success'
          stylingMode='contained'
          onClick={toggleModal}
        >
          {`View ${e.data.files.length} Result Files`}
        </ICSButton>,
      ]
    : []
}

export default renderFiles
